export default __webpack_public_path__ + "static/media/pukanina4.4410a8c1.jpg";